/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/no-extraneous-dependencies */
// import DateFnsUtils from "@date-io/date-fns";
// import format from "date-fns/format";
import React from "react";

import { styled } from "@mui/material/styles";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, DatePickerToolbar } from "@mui/x-date-pickers";
import { PickersCalendarHeader } from "@mui/x-date-pickers/PickersCalendarHeader";
import { PickersActionBar } from "@mui/x-date-pickers/PickersActionBar";

import ja from "date-fns/locale/ja";

const StyledDatePicker = styled(DatePicker)({
    "& .MuiFormLabel-root.MuiInputLabel-root": {
        // default: transform: "translate(14px, 16px) scale(1)",
        transform: "translate(14px, 8px) scale(1)",
    },
    "& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-shrink": {
        // デフォルト通りだけど、書いておかないとフォーカス時に↑が適用される
        transform: "translate(14px, -9px) scale(0.75)",
    },
    "& .MuiOutlinedInput-root": {
        height: "37.4px",
        borderRadius: "10px",
        backgroundColor: "#F5F6F6",
        "&:hover fieldset": {
            borderColor: "#BB0D2F",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#BB0D2F",
        },
    },
    "& label.Mui-focused": {
        color: "#BB0D2F",
    },
    "& .MuiTextField-root": {
        alignItems: "center",
    },
});

/** DatePickerToolbarのカスタマイズ */
const SompoDatePickerToolbar = (props: any) => {
    const { date, isLandscape, onChange, ...other } = props;
    return (
        <DatePickerToolbar
            toolbarPlaceholder="(未選択)"
            toolbarFormat="yyyy/MM/dd"
            isLandscape={isLandscape}
            onChange={onChange}
            value={date}
            view={date}
            {...other}
        />
    );
};

/** PickersCalendarHeaderのカスタマイズ */
const SompoDatePickerHeader = (props: any) => {
    return <PickersCalendarHeader format="yyyy年 MM月" {...props} />;
};

/** PickersActionBarのカスタマイズ */
const SompoDatePickerActionBar = (props: any) => {
    return <PickersActionBar actions={["cancel", "clear", "accept"]} {...props} />;
};

interface SompoDatePickerProps {
    label: string;
    name: string;
    value?: Date;
    onChange: (date: Date | null) => void;
}

export const SompoDatePicker = (props: SompoDatePickerProps) => {
    return (
        <StyledDatePicker
            {...props}
            format="yyyy/MM/dd"
            views={["year", "month", "day"]}
            slots={{
                toolbar: SompoDatePickerToolbar,
                calendarHeader: SompoDatePickerHeader,
                actionBar: SompoDatePickerActionBar,
            }}
            slotProps={{
                actionBar: ({ wrapperVariant }) => ({
                    actions: wrapperVariant === "desktop" ? ["clear", "cancel"] : ["accept", "clear", "cancel"],
                }),
            }}
        />
    );
};

interface DatePickersProviderProps {
    children?: React.ReactNode;
}
function SompoDatePickers(props: DatePickersProviderProps) {
    const { children } = props;
    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={ja}
            dateFormats={{ year: "yyyy年", month: "MM月" }}
            localeText={{
                datePickerToolbarTitle: "日付を選択",
                previousMonth: "次の月",
                nextMonth: "前の月",
                cancelButtonLabel: "キャンセル",
                clearButtonLabel: "クリア",
                okButtonLabel: "選択",
            }}
        >
            {children}
        </LocalizationProvider>
    );
}

export default SompoDatePickers;
